import { render, staticRenderFns } from "./LoadMoreBtn.vue?vue&type=template&id=1d6ce58a&scoped=true"
import script from "./LoadMoreBtn.vue?vue&type=script&lang=ts"
export * from "./LoadMoreBtn.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./LoadMoreBtn.vue?vue&type=style&index=0&id=1d6ce58a&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1d6ce58a",
  "7be74b3e"
  
)

export default component.exports